import { Component, OnInit } from '@angular/core';
import { BBWTMessageService, TelephonyService } from '../../../services';
import { ITelephonyUser } from '../../../interfaces/telephony/telephony-user.interface';

@Component({
  selector: 'app-telephony-users',
  templateUrl: './telephony-users.component.html',
  styleUrls: ['./telephony-users.component.scss'],
})
export class TelephonyUsersComponent implements OnInit {
  constructor(
    private telephonyService: TelephonyService,
    private messageService: BBWTMessageService,
  ) {}

  isLoading = false;
  users: ITelephonyUser[] = [];
  allUsers: ITelephonyUser[];

  searchUserName: any;

  ngOnInit(): void {
    void this.loadRCUsers();
  }

  async loadRCUsers() {
    try {
      this.isLoading = true;
      this.allUsers = await this.telephonyService.getTelephonyUsers();
      this.users = this.allUsers;
    } catch (error) {
      this.messageService.ShowError('Error', 'Failed to retrieve telephony users');
    } finally {
      this.isLoading = false;
    }
  }

  changeUserEnabled(data: ITelephonyUser) {
    this.telephonyService.updateTelephonyUser(data).then((res) => {
      if (res) {
        const index = this.allUsers.findIndex((x) => x.id === res.id);
        this.allUsers[index] = res;

        this.onUserSearch();
      }
    });
  }

  onUserSearch() {
    if (this.searchUserName?.length >= 0) {
      this.users = this.allUsers.filter(
        (x) =>
          x.firstName.toLowerCase().includes(this.searchUserName.toLowerCase()) ||
          x.lastName.toLowerCase().includes(this.searchUserName.toLowerCase()),
      );
    } else {
      this.users = this.allUsers;
    }
  }

  async syncUsers() {
    try {
      this.isLoading = true;
      await this.telephonyService.syncTelephonyUsers();
      this.messageService.ShowSuccess('Success', 'Synced telephony users');
    } catch (error) {
      this.messageService.ShowError('Error', 'Failed to sync telephony users');
    } finally {
      void this.loadRCUsers();
    }
  }

  protected asTelephonyUser(data: any): ITelephonyUser {
    return data as ITelephonyUser;
  }
}
